<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.qrcode')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="qrcode">
          <b-row class="mb-5">
            <b-col xxs="12">
            <p class="error">{{ error }}</p>

            <!-- <p class="decode-result">값: <b>{{ result }}</b></p> -->

            <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
              <div v-show="showScanConfirmation" class="scan-confirmation">
                <!-- <img :src="$withBase('/checkmark.svg')" alt="Checkmark" width="128px" /> -->
                <span>체크</span>
              </div>
            </qrcode-stream>
            </b-col>
          </b-row>
        </b-card>
      </b-colxx>
    </b-row>
    <!-- qr코드 모달 -->
    <template>
      <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
        <b-modal id="qrcodemodal" ref="qrcodemodal" size="xl" title="쿠폰 상세 내역" :hide-backdrop="false"
                 :no-close-on-backdrop="true">
          <qrcode-modal @hideModar="hideModal" :qrcodeProps="qrcodeArray">
          </qrcode-modal>
          <template slot="modal-footer">
            <b-button variant="outline-primary" @click="hideModal">닫기</b-button>
          </template>
        </b-modal>
      </b-row>
    </template>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import  QrcodeModal from "../../components/Pages/QrcodeModal";
import api from '../../constants/api';
import {
  mapGetters,
  mapActions,
  mapMutations
} from "vuex";

export default {

  components: { 
    QrcodeStream,
    'qrcode-modal': QrcodeModal,
  },

  data () {
    return {
      result: null,
      error: '',
      qrcodeArray:[],
      camera: 'auto',
      showScanConfirmation: false
    }
  },
  computed:{
    ...mapGetters(['currentUser', 'siteName', 'brandInfo']),
  },
  methods: {
    showModal() {
      this.$refs['qrcodemodal'].show();
    },
    hideModal() {
      this.$refs['qrcodemodal'].hide();
    },
    async onDecode(result) {
      const reqURL = api.changeAPI(this.siteName, api.basicURL + api.coupon.couponList)
      const params = {
        dateFrom: null,
        dateTo:null,
        keyword:result,
        keywordType: 'ItemNo',
      }
      this.$http.post(reqURL, params, {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        if(res.data.code === "OK") {
          if(res.data.data == ""){
            alert('없는 쿠폰이거나 현재 매장에서 사용불가 쿠폰입니다.');
            return false;
          }
          this.qrcodeArray = res.data.data
          console.log(res.data.data);
          this.showModal();
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
        this.pause()
        await this.timeout(500)
        this.unpause()
    },
    unpause () {
      this.camera = 'auto'
    },

    pause () {
      this.camera = 'off'
    },

    timeout (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    async onInit (promise) {
      try {
        await promise
      } catch (e) {
        // console.error(e)
        if (e.name === 'NotAllowedError') {
          this.e = "ERROR:  카메라 접근을 허가해야 합니다."
          alert(e.error);
        } else if (e.name === 'NotFoundError') {
          this.e = "ERROR: 이 장치에 카메라가 없습니다."
          alert(this.e);
        } else if (e.name === 'NotSupportedError') {
          this.e = "ERROR: 보안 컨텍스트 필요(HTTPS, localhost)"
          alert(this.e);
        } else if (e.name === 'NotReadableError') {
          this.e = "ERROR: 카메라는 이미 사용중입니까?"
          alert(this.e);
        } else if (e.name === 'OverconstrainedError') {
          this.e = "ERROR: 설치된 카메라는 적합하지 않습니다."
          alert(this.e);
        } else if (e.name === 'StreamApiNotSupportedError') {
          this.e = "ERROR: 이 브라우저에서는 스트림 API가 지원되지 않습니다."
          alert(this.e);
        }
      } finally {
        this.showScanConfirmation = this.camera === "off"
      }
    }
  }
}
</script>

<style>

</style>